import React, {Component} from 'react'
import styles from './List.css'
import ListItem from '../../components/ListItem/ListItem'
import PropTypes from 'prop-types'
import {ListLayoutType} from '../../constants/consts-types'
import {isDesktop, getViewPortWidth} from '../../services/service-utils'
import {TypeListItem} from '../../constants/consts-prop-types'

const colArrayTemplate = [3, 4, 3, 3, 3, 4, 4, 3, 3]
let colArrayIndex = 0

// For mobile-slider items (ListFeatured). Shows the first item plus a fraction of the next item:
const numInviewMobile = 1.084

class List extends Component {
  static propTypes = {
    listItems: PropTypes.arrayOf(TypeListItem).isRequired,
    layout: PropTypes.string.isRequired,
    numInview: PropTypes.number,
    currentIndex: PropTypes.number,
  }

  static defaultProps = {
    layout: ListLayoutType.GRID,
    numInview: numInviewMobile,
    currentIndex: 0
  }

  constructor(props) {
    super(props)

    this.state = {
      itemHeights: [],
      imageHeightMax: 0,
      isDesktop: isDesktop(),
      viewPortWidth: getViewPortWidth(),
      itemWidth: 0,
      itemWidthGap: 0,
      rowWidth: 0,
    }

    this.slideToCurrentIndex = this.slideToCurrentIndex.bind(this)
    this.getGridColumnClass = this.getGridColumnClass.bind(this)
    this.equalizeHeightsInRow = this.equalizeHeightsInRow.bind(this)
    this.onResize = this.onResize.bind(this)
    this.renderListItem = this.renderListItem.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize)
    this.onResize()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  componentDidUpdate(prevProps) {
    if(prevProps.currentIndex !== this.props.currentIndex) {
      this.slideToCurrentIndex(this.props.currentIndex)
    }

    const differentItems = this.props.listItems.some((newItem, idx) => {
      const prevItem = prevProps.listItems && prevProps.listItems[idx] ? prevProps.listItems[idx] : null
      return Boolean(prevItem && newItem.id !== prevItem.id)
    })

    if(differentItems) {
      this.setState({
        itemHeights: []
      })
    }
  }

  onResize() {
    const viewPortWidth = getViewPortWidth()
    if(viewPortWidth === this.state.viewPortWidth) return

    const isDeskTop = isDesktop()
    const itemWidth = 100 / 14 * 12 / (isDeskTop ? this.props.numInview : numInviewMobile)
    const itemWidthGap = 100 / 14 * 13 / (isDeskTop ? this.props.numInview : numInviewMobile)
    const rowWidth = itemWidthGap * this.props.listItems.length

    this.setState({
      itemHeights: [],
      isDesktop: isDeskTop,
      viewPortWidth: viewPortWidth,
      itemWidth,
      itemWidthGap,
      rowWidth,
    }, () => {
      this.slideToCurrentIndex(this.props.currentIndex)
    })
  }

  slideToCurrentIndex(index) {
    const xPosRow = (index * this.state.itemWidthGap) * -1
    window.TweenLite.to(this.rowNode, .35, {transform: `translateX(${xPosRow}vw)`, ease: window.Power2.easeInOut})
  }

  equalizeHeightsInRow(index, height) {
    switch(this.props.layout) {
      case ListLayoutType.GRID:
        this.setState(prevState => {
          const newState = prevState.itemHeights
          const columnIndex = index % 3

          const firstInRowHeight = newState[index + 0 - columnIndex] || 0
          const secondInRowHeight = newState[index + 1 - columnIndex] || 0
          const thirdInRowHeight = newState[index + 2 - columnIndex] || 0

          const maxHeight = Number(Math.max(height, firstInRowHeight, secondInRowHeight, thirdInRowHeight).toFixed(2))

          newState[index + 0 - columnIndex] = maxHeight
          newState[index + 1 - columnIndex] = maxHeight
          newState[index + 2 - columnIndex] = maxHeight

          return {
            itemHeights: [...newState]
          }
        })
        break;
      case ListLayoutType.SLIDER:
        this.setState(prevState => {
          return {
            imageHeightMax: Math.max(prevState.imageHeightMax, height)
          }
        })
        break;
      default:
        break;
    }
  }

  getGridColumnClass(columnIndex) {
    if(colArrayIndex === colArrayTemplate.length) colArrayIndex = 0
    const useThisColSpan = colArrayTemplate[colArrayIndex]
    colArrayIndex++
    return columnIndex === 0 ? `col-xs-12 col-md-${useThisColSpan}` : `col-xs-12 col-md-${useThisColSpan} col-md-offset-1`
  }

  renderListItem(data, idx) {
    const {layout} = this.props
    const columnIndex = idx % 3
    const colClasses = layout === ListLayoutType.GRID ? this.getGridColumnClass(columnIndex) : styles.sliderColumn
    const itemData = {...data}
    itemData.imageContainerHeightEqualized = layout === ListLayoutType.GRID ? this.state.itemHeights[idx] : this.state.imageHeightMax

    const stylesColumn = layout === ListLayoutType.SLIDER ? {
      width: `${this.state.itemWidth}vw`,
      marginRight: `${100 / 14}vw`
    } : {}

    return (
      <div key={idx} className={colClasses} style={stylesColumn}>
        <ListItem
          index={idx}
          columnIndex={columnIndex}
          data={itemData}
          isDesktop={this.state.isDesktop}
          equalizeHeightsInRow={this.equalizeHeightsInRow}
          layout={layout}
        />
      </div>
    )
  }

  render() {
    colArrayIndex = 0

    const {
      listItems,
      layout,
    } = this.props

    const rowClasses = `row ${styles['row' + layout]}`

    const rowStyles = layout === ListLayoutType.SLIDER ? {
      width: `${this.state.rowWidth}vw`,
    } : {}

    return (
      <div className={styles.List} style={this.props.style}>
        <div className='container-fluid'>
          <div
            ref={node => this.rowNode = node}
            className={rowClasses}
            style={rowStyles}
          >
            {listItems && listItems.length > 0 &&
            listItems.map((item, idx) => this.renderListItem(item, idx))
            }
          </div>
        </div>
      </div>
    )
  }
}

export default List



// WEBPACK FOOTER //
// ./src/components/List/List.js